import React from "react";

const title = "Contact Preferences";

export const contentTypesAvailable = {
  Mol: "Mol",
  MolAlternate: "MolAlternate",
  Hol: "Hol",
  HolAlternate: "HolAlternate"
};

export default {
  Mol: {
    title: title,
    body: {
      paragraph1: (
        <p>
          By registering for our Member Online service, your method for managing
          your plan will automatically be set to 'Online'. This means that we'll
          email you at the end of your plan year with details of your next
          year's renewal terms and premium and email you whenever there is
          something new for you to view online. With our Member Online service
          you'll only be able to access your policy documents by logging in.
        </p>
      ),
      paragraph2: (
        <p>
          If you'd prefer to receive your renewal document and other documents
          by post you can amend your preference for managing your plan in the
          'My profile' section of the Member Online service. You can also
          request paper copies of your documents by calling us on{" "}
          <strong>0800 302 9133</strong>.
        </p>
      )
    },

    button: "Continue"
  },
  MolAlternate: {
    title: title,
    body: {
      paragraph1: (
        <p>
          By registering with our Member Online service, your method for
          receiving your claims information will automatically be set to
          'Online'. This means that we'll email you whenever there is something
          new for you to view online. With our Member Online service you'll only
          be able to access your claims documents by logging in.
        </p>
      ),
      paragraph2: (
        <p>
          If you'd prefer to receive your claims documents by post you can amend
          your preference in the 'My profile' section of the Member Online
          service. You can also request paper copies of your documents by
          calling us on <strong>0800 302 9133</strong>.
        </p>
      )
    },

    button: "Continue"
  },
  Hol: {
    title: title,
    body: {
      paragraph1: (
        <p>
          By registering for our Customer Online service, your method for
          managing your policy will automatically be set to 'Online'. This means
          that we'll email you at the end of your policy year with details of
          your next year's renewal terms and premium and email you whenever
          there is something new for you to view online. With our Customer
          Online service you'll only be able to access your policy documents by
          logging in.
        </p>
      ),
      paragraph2: (
        <p>
          If you'd prefer to receive your renewal document and other documents
          by post you can amend your preference for managing your policy in the
          'My account' section of the Customer Online service. You can also
          request paper copies of your documents by calling us on{" "}
          <strong>01202 544032</strong>.
        </p>
      )
    },

    button: "Continue"
  },
  HolAlternate: {
    title: title,
    body: {
      paragraph1: (
        <p>
          By registering with our Customer Online service, your method for
          receiving your claims information will automatically be set to
          'Online'. This means that we'll email you whenever there is something
          new for you to view online. With our Customer Online service you'll
          only be able to access your claims documents by logging in.
        </p>
      ),
      paragraph2: (
        <p>
          If you'd prefer to receive your renewal document and other documents
          by post you can amend your preference for managing your policy in the
          'My account' section of the Customer Online service. You can also
          request paper copies of your documents by calling us on{" "}
          <strong>01202 544032</strong>.
        </p>
      )
    },

    button: "Continue"
  }
};
